import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { NavMarker } from 'react-rhumb';
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import styled from 'styled-components';
import { AnimatedStepBody } from '../animation/StepBodyAnimations';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { OAuthSignupSection } from '../oauth/OAuthSignupSection';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { Data } from '../signup-data/DATA';
import { SignupDataInputForm } from '../signup-data/SignupDataInputForm';
import { useTracker } from '../tracking/useTracker';
import CreateAccountTermsOfService from '../views-components/CreateAccountTermsOfService';
import PrivacyBanner from '../views-components/PrivacyBanner';
import { Step } from '../views/Step';
import { getLandingPageButton } from './getLandingPageText';
import { HaveAnAccountLink } from './HaveAnAccountLink';
import { SignupWithEmailButton } from './LandingPageSignupWithEmailButton';
import { LandingPageTitle } from './LandingPageTitle';
import { useLandingPage } from './useLandingPage';
const EmbeddedHaveAnAccount = styled.div.withConfig({
  displayName: "LandingPageView__EmbeddedHaveAnAccount",
  componentId: "sc-176kln1-0"
})(["", ""], props => props.theme.embedded && `
      margin-top: 1.5rem;
      font-size: 14px;
      margin-bottom: 1.5rem;
    `);

const LandingPageView = () => {
  const tracker = useTracker();
  const stepKey = Step.LandingPage;
  const shouldShowTos = getFlowConfig().shouldShowTosOnLandingPage;
  const {
    chooseEmailSignUp
  } = useLandingPage(stepKey);
  const {
    isMobile
  } = useResponsiveness();
  const {
    isActive: isInstanceOfSignupEmbedder
  } = useSignupEmbedder();
  const [hasChosenToSignupWithEmail, setHasChosenToSignupWithEmail] = useState(false);
  useExperiment(ExperimentKeys.ACQ133, TrackWhen.enrolled);
  const {
    isAssignedToVariant: isAssignedToVariantACQ128
  } = useExperiment(ExperimentKeys.ACQ128, TrackWhen.enrolled);

  const Footer = () => {
    return isInstanceOfSignupEmbedder ? /*#__PURE__*/_jsxs(EmbeddedHaveAnAccount, {
      className: "text-center",
      children: [/*#__PURE__*/_jsx(HaveAnAccountLink, {}), /*#__PURE__*/_jsx(PrivacyBanner, {})]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PrivacyBanner, {}), shouldShowTos && /*#__PURE__*/_jsx(CreateAccountTermsOfService, {})]
    });
  };

  const signupWithEmail = () => {
    tracker.signupInteraction('signup-with-email-button-click');
    setHasChosenToSignupWithEmail(true);
  };

  return /*#__PURE__*/_jsx(NavMarker, {
    name: Step.LandingPage,
    children: /*#__PURE__*/_jsx(AnimatedStepBody, {
      animationDelay: true,
      children: /*#__PURE__*/_jsxs("div", {
        "data-selenium": `${stepKey}_VIEW`,
        children: [/*#__PURE__*/_jsx(LandingPageTitle, {
          isMobile: isMobile
        }), /*#__PURE__*/_jsx(OAuthSignupSection, {}), isAssignedToVariantACQ128() && !hasChosenToSignupWithEmail ? /*#__PURE__*/_jsx(SignupWithEmailButton, {
          onClick: signupWithEmail
        }) : /*#__PURE__*/_jsx(SignupDataInputForm, {
          autoFocus: false,
          buttonProps: {
            label: getLandingPageButton()
          },
          dataKey: Data.Email,
          inputMode: 'email',
          shouldTrimData: true,
          submit: chooseEmailSignUp
        }, Data.Email), /*#__PURE__*/_jsx(Footer, {})]
      })
    })
  });
};

export default LandingPageView;